const features = [
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式阅读',
    desc: '采用先进的下拉式阅读技术，告别传统翻页模式，漫画内容上下连贯无缝衔接，阅读速度提升三倍。',
  },
  {
    icon: 'ri-check-double-line',
    title: '免费全集无删减',
    desc: '所有漫画均为完整版无删减内容，绝不遗漏任何画面与台词。纯免费模式，无需付费即可畅享全部作品。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '每日同步更新',
    desc: '与各大漫画平台同步更新，最新话第一时间上线。热门作品实时追踪，不错过任何精彩剧情发展。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">平台特色</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">为什么百万读者选择羞羞歪歪漫画</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-[960px] mx-auto">
          {features.map((feat) => (
            <div key={feat.title} className="bg-background-100 rounded-xl p-6 md:p-7 border border-background-200/70 text-center">
              <span className="w-14 h-14 rounded-2xl bg-primary-100 text-primary-600 flex items-center justify-center mx-auto mb-4">
                <i className={`${feat.icon} text-2xl`}></i>
              </span>
              <h3 className="text-base font-semibold text-foreground-900 mb-3">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}